<template>
    <div v-if="value" :data-qa="dataQa" class="crefo-ui-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h2>{{ headline }}</h2>
                <span
                    class="modal-close"
                    @click="onCloseEmit('close', $event)"
                />
            </div>
            <div class="modal-body">
                <p :data-qa="dataQa + 'message'" v-html="message" />
                <p v-if="correlationId" class="text-small correlationId">
                    Correlation-ID: {{ correlationId }}
                </p>
                <button
                    class="btn btn-default mt"
                    :data-qa="dataQa + 'CloseButton'"
                    @click="onCloseEmit('confirm', $event)"
                >
                    {{ closeButtonTextValue }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
/**
     * The default Crefo failure modal (Wrapper for the `CrefoDialog` component)
     */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const emits = defineEmits(['input', 'closeAction'])

const {
    value,
    headline,
    message,
    closeButtonText,
    closeButtonEmit,
    dataQa,
    correlationId
} = defineProps({
    value: {
        type: Boolean,
        default: false,
        required: true
    },
    // The failure modal headline
    headline: {
        type: String,
        default: 'Fehler'
    },
    // The failure modal body content
    message: {
        type: String,
        default: ''
    },
    /**
         * The failure modal close button text.
         * The default value is received from a computed property
         * (to be able to access translations).
         */
    closeButtonText: {
        type: String,
        default: null
    },
    closeButtonEmit: {
        type: String,
        default: null
    },
    dataQa: {
        type: String,
        default: 'dialog'
    },
    correlationId: {
        type: String,
        default: null
    }
})

const closeButtonEmitValue = computed(() => {
    return closeButtonEmit || ''
})

const closeButtonTextValue = computed(() => {
    return closeButtonText === null || !closeButtonText.length
        ? t('Dialog.Default.Close')
        : closeButtonText
})

const onCloseEmit = whichBtn => {
    emits('input', false)
    emits('closeAction', closeButtonEmitValue.value, whichBtn)
}
</script>

<style scoped lang="less">
    .correlationId {
        margin-top: 15px;
    }

    .close {
        position: relative;
        cursor: pointer;

        &:after {
            content: ' ';
            cursor: pointer;
            display: inline-block;
            z-index: 3;
            background: url(../../assets/app-icons/icon-dialog-close.svg);
            width: 19px;
            height: 19px;
            position: absolute;
            right: 0;
            top: 0;
        }
    }
    @-moz-document url-prefix() {
        .close::after {
            top: 27px !important; // target weird Firefox CSS bug
        }
    }
</style>
